import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["items", "orientation", "sx", "noPadding", "handleChange", "tabIndex", "scrollButtons"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Box, Tab, Tabs as MuiTabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Tabs = function Tabs(_ref) {
  var items = _ref.items,
      orientation = _ref.orientation,
      sx = _ref.sx,
      noPadding = _ref.noPadding,
      _ref$handleChange = _ref.handleChange,
      handleChange = _ref$handleChange === void 0 ? function (fn) {
    return fn();
  } : _ref$handleChange,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex,
      _ref$scrollButtons = _ref.scrollButtons,
      scrollButtons = _ref$scrollButtons === void 0 ? false : _ref$scrollButtons,
      other = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(tabIndex),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    return setValue(tabIndex);
  }, [tabIndex, setValue]);
  return /*#__PURE__*/_jsxs(Box, {
    sx: orientation === 'vertical' ? {
      flexGrow: 1,
      display: 'flex'
    } : {},
    "data-element": "Box",
    "data-component": "Tabs",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(MuiTabs, _objectSpread(_objectSpread({
      orientation: orientation,
      value: value,
      onChange: function onChange(_, newValue) {
        return handleChange(function () {
          return setValue(newValue);
        }, newValue);
      },
      variant: "scrollable",
      scrollButtons: scrollButtons,
      TabIndicatorProps: {
        style: {
          transitionProperty: 'top, left'
        }
      },
      sx: mergeSxProps({
        borderRight: orientation === 'vertical' ? 1 : 0,
        borderBottom: orientation === 'vertical' ? 0 : 1,
        borderColor: 'divider'
      }, sx)
    }, other), {}, {
      "data-element": "MuiTabs",
      "data-component": "Tabs",
      "data-source-file": "index.tsx",
      children: items.map(function (_ref2) {
        var label = _ref2.label,
            onClick = _ref2.onClick,
            disabled = _ref2.disabled;
        return /*#__PURE__*/_jsx(Tab, {
          tabIndex: 0,
          sx: {
            alignItems: orientation === 'vertical' ? 'flex-start' : 'center',
            '&:hover': {
              color: function color(t) {
                return t.palette.primary.main;
              }
            }
          },
          label: label,
          disabled: disabled,
          onClick: onClick
        }, label);
      })
    })), items.map(function (_ref3, index) {
      var component = _ref3.component,
          label = _ref3.label;
      return value === index ? /*#__PURE__*/_jsx(Box, {
        sx: noPadding ? {
          p: 0
        } : orientation === 'vertical' ? {
          px: 4
        } : {
          py: 3
        },
        children: component
      }, label) : null;
    })]
  });
};